import { Component, Input } from '@angular/core';

import { FileData, FileService, NotificationService, ProductDetails } from 'tms-lib';
import { ProductLogoService } from '../../../services';

@Component({
  selector: 'app-product-logo',
  templateUrl: './product-logo.component.html',
  styleUrl: './product-logo.component.scss',
})
export class ProductLogoComponent {
  @Input() product: ProductDetails;
  @Input() showBrowse = true;
  @Input() showRemove = true;
  @Input() largeHeader = true;
  @Input() header = '';
  @Input() width = 200;
  @Input() height = 150;
  @Input() image2 = false;

  fileFormData: FormData;

  constructor(
    private notificationService: NotificationService,
    private productLogoService: ProductLogoService,
    private fileService: FileService,
  ) {}

  get logo(): FormData {
    return this.fileFormData;
  }

  save(file: FileData) {
    this.fileFormData = this.fileService.imageToFormData(file.src);

    if (this.product) {
      this.upload(file.name);
    }
  }

  upload(filename: string) {
    this.productLogoService
      .uploadImage(this.product.id, filename, this.fileFormData, this.image2)
      .subscribe((imagePath: string) => {
        this.updateProduct(imagePath);
        this.notificationService.success($localize`Logo uploaded successfully`);
      });
  }

  remove() {
    this.productLogoService.removeImage(this.product.id, this.image2).subscribe({
      next: (imagePath: string) => {
        this.updateProduct(imagePath);
        this.notificationService.success($localize`Logo removed successfully`);
      },
      error: () => {},
    });
  }

  private updateProduct(imagePath) {
    this.product = this.image2 ? { ...this.product, imagePath2: imagePath } : { ...this.product, imagePath: imagePath };
  }
}
